import type { ReactNode } from "react"

/**
 * Etiqueta y control, atados por `id`.
 *
 * ⚠ **`htmlFor` no es adorno**: es lo que hace que pulsar el rótulo enfoque el
 * campo, y lo que un lector de pantalla anuncia al llegar a él. Un `<label>` suelto
 * deja el control sin nombre accesible.
 */
export function CampoDeFicha({
  id,
  etiqueta,
  children,
}: {
  id: string
  etiqueta: string
  children: ReactNode
}) {
  return (
    <div>
      <label htmlFor={id} className="mb-1 block text-xs font-medium uppercase">
        {etiqueta}
      </label>
      {children}
    </div>
  )
}
